import { render, staticRenderFns } from "./ExpertTermsConditionBadge.vue?vue&type=template&id=1e879c64"
import script from "./ExpertTermsConditionBadge.vue?vue&type=script&lang=js"
export * from "./ExpertTermsConditionBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports